export enum MoveDirection {
  Up,
  Down
}
